module.exports = __webpack_public_path__ + "img/ic_download.63a16862.svg";